import React from "react";
import ChatHeader from "./components/chat-header/chat-header";
import ChatBox from "./components/chat-box/chat-box";
import styles from "./chat-details.module.css";
import { useChat } from "../../../../context/chat-context";
import { uploadDocuments } from "../../../../services/communication";
import { toast } from "react-toastify";

const ChatDetails = ({ selectedChat, setSelectedChat, chatRules }) => {
  const { socket, chatHistory, sendMessage } = useChat();
  const realtimeChat = chatHistory?.find((u) => 
    u?.user_id === selectedChat?.user_id
  );

  const handleSend = async (msg, attachmentFiles = []) => {
    if (!socket) return;

    const attachments = await getAttachmentUrls(attachmentFiles);
    if (attachmentFiles?.length > 0 && !attachments) return false;

    if (selectedChat?.user_id) {
      const socketPayload = {
        receiverId: selectedChat?.user_id,
        content: msg,
      };
      if (attachments?.length > 0) {
        socketPayload.attachmentUrls = attachments;
      }
      sendMessage(socketPayload);
    }
    return true;
  };

  const getAttachmentUrls = async (attachmentFiles) => {
    if (attachmentFiles?.length === 0) return false;

    const formData = new FormData();
    attachmentFiles?.forEach((file) => {
      formData.append("files", file?.originFileObj);
    });

    try {
      const res = await uploadDocuments(formData);

      if (res?.data?.status && Array.isArray(res?.data?.data)) {
        return res?.data?.data;
      }
      return false;
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("Failed to upload attachments");
      return false;
    }
  };

  return (
    <div className={styles["chat-details-container"]}>
      <ChatHeader 
        name={selectedChat?.user_name || "Unknown User"}
        designation={selectedChat?.user_role}
        imgUrl={selectedChat?.profile_url}
        isOnline={realtimeChat?.isOnline}
        setSelectedChat={setSelectedChat}
      />
      <ChatBox 
        selectedChat={selectedChat}
        onSend={handleSend}
        chatRoles={chatRules?.can_message || []}
      />
    </div>
  );
};

export default ChatDetails;